import { parseJSON, checkCode } from '../utils/api';
import { SubmissionError } from 'redux-form';
import { checkAccess } from './assets';
import InPlayer from '@inplayer-org/inplayer.js';

export const CARD_PAYMENT_REQUEST = 'CARD_PAYMENT_REQUEST';
export const CARD_PAYMENT_FAILURE = 'CARD_PAYMENT_FAILURE';
export const CARD_PAYMENT_SUCCESS = 'CARD_PAYMENT_SUCCESS';
export const CARD_PAYMENT_SUBMITTED = 'CARD_PAYMENT_SUBMITTED';

export const cardPayment = paymentObj => {
    return async (dispatch, getState) => {
        const payment = getState().payments;
        if (payment.isProcessing || payment.isSubmitted) {
            return null;
        }

        dispatch({ type: CARD_PAYMENT_REQUEST });

        const paymentObject = {
            number: paymentObj.cardNumber,
            cardName: paymentObj.cardName,
            expMonth: paymentObj.expiryValue
                ? paymentObj.expiryValue.month
                : '',
            expYear: paymentObj.expiryValue ? paymentObj.expiryValue.year : '',
            cvv: paymentObj.cvc,
            accessFee: paymentObj.selectedFee.id,
            paymentMethod: paymentObj.paymentMethod,
            referrer: paymentObj.referrer,
        };

        if (paymentObj.voucherCode) {
            paymentObject.voucherCode = paymentObj.voucherCode;
        }

        try {
            InPlayer.Payment.payForAsset(
                InPlayer.Account.getToken().token,
                paymentObject
            ).then(data => {
                dispatch({
                    type: CARD_PAYMENT_SUBMITTED,
                    data,
                    id: paymentObj.assetID,
                });
            });
        } catch (error) {
            let data = await parseJSON(error.response);
            dispatch({ type: CARD_PAYMENT_FAILURE });
            throw new SubmissionError({ _error: data, ...data.errors });
        }
    };
};

export const DISCOUNT_REQUEST = 'DISCOUNT_REQUEST';
export const DISCOUNT_SUCCESS = 'DISCOUNT_SUCCESS';
export const DISCOUNT_FAILURE = 'DISCOUNT_FAILURE';

export const getDiscount = (code, accessFeeId, uuid) => {
    return async dispatch => {
        dispatch({ type: DISCOUNT_REQUEST });

        const discountObj = {
            voucherCode: code,
            merchantUuid: uuid,
            accessFeeId: accessFeeId,
        };

        try {
            InPlayer.Voucher.getDiscount(
                InPlayer.Account.getToken().token,
                discountObj
            ).then(data => {
                if (checkCode(data) && code !== '') {
                    dispatch({ type: DISCOUNT_SUCCESS, data });
                } else {
                    dispatch({ type: DISCOUNT_FAILURE, data });
                }
            });
        } catch (error) {
            let data = await parseJSON(error.response);
            dispatch({ type: DISCOUNT_FAILURE });
            throw new SubmissionError({ _error: data, ...data.errors });
        }
    };
};

export const FREEMIUM_PAYMENT_REQUEST = 'FREEMIUM_PAYMENT_REQUEST';
export const FREEMIUM_PAYMENT_SUCCESS = 'FREEMIUM_PAYMENT_SUCCESS';
export const FREEMIUM_PAYMENT_FAILURE = 'FREEMIUM_PAYMENT_FAILURE';

export const freemium = (accessFeeId, assetId, uuid) => {
    return async dispatch => {
        dispatch({ type: FREEMIUM_PAYMENT_REQUEST });

        try {
            InPlayer.Asset.getFreemiumAsset(
                InPlayer.Account.getToken().token,
                accessFeeId
            ).then(data => {
                dispatch({ type: FREEMIUM_PAYMENT_SUCCESS, data });
                dispatch(checkAccess(assetId, uuid));
            });
        } catch (error) {
            dispatch({ type: FREEMIUM_PAYMENT_FAILURE });
        }
    };
};

export const PAYMENT_METHODS_REQUEST = 'PAYMENT_METHODS_REQUEST';
export const PAYMENT_METHODS_SUCCESS = 'PAYMENT_METHODS_SUCCESS';
export const PAYMENT_METHODS_FAILURE = 'PAYMENT_METHODS_FAILURE';

export const getPaymentMethods = () => {
    return async (dispatch, getState) => {
        const payment = getState().payments;
        if (payment.paymentMethods) {
            return null;
        }

        dispatch({ type: PAYMENT_METHODS_REQUEST });

        try {
            InPlayer.Payment.getPaymentMethods(
                InPlayer.Account.getToken().token
            ).then(data => {
                dispatch({ type: PAYMENT_METHODS_SUCCESS, data });
            });
        } catch (error) {
            dispatch({ type: PAYMENT_METHODS_FAILURE });
        }
    };
};

export const PAYPAL_PARAMS_REQUEST = 'PAYPAL_PARAMS_REQUEST';
export const PAYPAL_PARAMS_SUCCESS = 'PAYPAL_PARAMS_SUCCESS';
export const PAYPAL_PARAMS_FAILURE = 'PAYPAL_PARAMS_FAILURE';

export const getPayPalParams = (accessFeeId, voucher) => {
    let paymentObj = {
        origin: window.location.href,
        accessFeeId: accessFeeId,
        paymentMethod: 2,
    };
    if (voucher !== '') paymentObj.voucherCode = voucher;

    return async dispatch => {
        dispatch({ type: PAYPAL_PARAMS_REQUEST });

        try {
            InPlayer.Payment.getPayPalParams(
                InPlayer.Account.getToken().token,
                paymentObj
            ).then(data => {
                dispatch({ type: PAYPAL_PARAMS_SUCCESS, data });
                window.location.href = data.endpoint;
            });
        } catch (error) {
            dispatch({ type: PAYPAL_PARAMS_FAILURE });
        }
    };
};

export const RESET_VOUCHER_VALUE = 'RESET_VOUCHER_VALUE';
export function resetVoucherValue() {
    return dispatch => {
        dispatch({
            type: RESET_VOUCHER_VALUE,
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/payments.js